var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-xl-12"},[_c('DataTable',{ref:"list",attrs:{"sent":_vm.sentTab}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }